import { clsx } from 'clsx'
import { motion } from 'framer-motion'

export function ProsperLogo({ className }: { className?: string }) {
	let transition = {
		duration: 0.5,
		ease: 'easeInOut',
	}

	return (
		<motion.svg
			xmlns="http://www.w3.org/2000/svg"
			variants={{ idle: {}, active: {} }}
			initial="idle"
			whileHover="active"
			width={100}
			height={100}
			viewBox="0 0 375 375"
			// preserveAspectRatio="xMidYMid meet"
			className={clsx(className, 'overflow-visible')}
		>
			<motion.defs>
				<motion.clipPath id="c042a766ba">
					<motion.path
						variants={{
							idle: { scale: 1, opacity: 1 },
							active: {
								scale: [1, 1.2, 1],
								opacity: [1, 0.9, 1],
								transition: {
									...transition,
									delay: 0.5,
								},
							},
						}}
						d="M 170 336.25 L 206.117188 336.25 L 206.117188 356.238281 L 170 356.238281 Z M 170 336.25 "
						clipRule="nonzero"
					/>
				</motion.clipPath>
				<motion.clipPath id="637050797e">
					<motion.path
						variants={{
							idle: { scale: 1, opacity: 1 },
							active: {
								scale: [1, 1.2, 1],
								opacity: [1, 0.9, 1],
								transition: {
									...transition,
									delay: 0.5,
								},
							},
						}}
						d="M 185 18.75 L 191 18.75 L 191 40 L 185 40 Z M 185 18.75 "
						clipRule="nonzero"
					/>
				</motion.clipPath>
				<motion.clipPath id="fe8f119705">
					<motion.path
						variants={{
							idle: { scale: 1, opacity: 1 },
							active: {
								scale: [1, 1.2, 1],
								opacity: [1, 0.9, 1],
								transition: {
									...transition,
									delay: 0.5,
								},
							},
						}}
						d="M 343.554688 202.730469 L 373.441406 202.730469 L 373.441406 208 L 343.554688 208 Z M 343.554688 202.730469 "
						clipRule="nonzero"
					/>
				</motion.clipPath>
				<motion.clipPath id="c59a20c785">
					<motion.path
						variants={{
							idle: { scale: 1, opacity: 1 },
							active: {
								scale: [1, 1.2, 1],
								opacity: [1, 0.9, 1],
								transition: {
									...transition,
									delay: 0.5,
								},
							},
						}}
						d="M 1.445312 201 L 31 201 L 31 207 L 1.445312 207 Z M 1.445312 201 "
						clipRule="nonzero"
					/>
				</motion.clipPath>
			</motion.defs>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 157.894531 120.917969 C 144.359375 120.917969 133.007812 131.488281 132.054688 144.980469 L 131.953125 146.398438 L 130.675781 147.019531 C 117.367188 153.496094 109.101562 166.707031 109.101562 181.5 C 109.101562 189.386719 111.484375 196.964844 115.992188 203.421875 L 116.582031 204.261719 L 116.394531 205.277344 C 116.328125 205.625 116.273438 205.976562 116.226562 206.332031 L 116.136719 207.027344 L 115.6875 207.570312 C 109.035156 215.664062 105.371094 225.898438 105.371094 236.398438 C 105.371094 258.753906 122.015625 278.0625 144.09375 281.3125 L 145.058594 281.457031 L 145.664062 282.226562 C 151.636719 289.8125 161.015625 294.757812 172.070312 296.160156 C 173.8125 296.382812 175.511719 295.859375 176.835938 294.6875 C 178.160156 293.519531 178.917969 291.839844 178.917969 290.078125 L 178.917969 121.25 C 178.917969 117.277344 176.03125 115.496094 173.558594 115.171875 C 171.113281 114.851562 167.902344 115.828125 166.894531 119.621094 L 166.25 122.183594 L 163.890625 121.621094 C 161.917969 121.152344 159.898438 120.917969 157.894531 120.917969 Z M 172.824219 301.121094 C 172.367188 301.121094 171.910156 301.09375 171.449219 301.035156 C 159.476562 299.519531 149.210938 294.203125 142.417969 286.027344 C 130.96875 284.113281 120.484375 278.242188 112.808594 269.425781 C 104.84375 260.277344 100.457031 248.546875 100.457031 236.398438 C 100.457031 225.09375 104.289062 214.0625 111.273438 205.214844 C 106.632812 198.160156 104.1875 189.988281 104.1875 181.5 C 104.1875 173.234375 106.527344 165.199219 110.957031 158.261719 C 115.011719 151.902344 120.640625 146.730469 127.285156 143.226562 C 129.082031 127.851562 142.261719 116 157.894531 116 C 159.546875 116 161.207031 116.136719 162.851562 116.40625 C 164.851562 112.109375 169.261719 109.65625 174.195312 110.296875 C 178.835938 110.902344 183.832031 114.589844 183.832031 121.25 L 183.832031 290.078125 C 183.832031 293.25 182.46875 296.273438 180.085938 298.375 C 178.066406 300.15625 175.480469 301.121094 172.824219 301.121094 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 146.34375 286.121094 C 144.917969 286.121094 143.488281 286.023438 142.074219 285.824219 L 142.75 280.957031 C 147.949219 281.679688 153.332031 280.8125 157.910156 278.511719 L 160.113281 282.90625 C 155.90625 285.019531 151.136719 286.121094 146.34375 286.121094 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 161.164062 284.753906 C 163.351562 283.441406 164.066406 280.605469 162.753906 278.417969 C 161.445312 276.226562 158.605469 275.511719 156.417969 276.824219 C 154.230469 278.136719 153.519531 280.972656 154.828125 283.160156 C 156.136719 285.351562 158.976562 286.0625 161.164062 284.753906 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 134.773438 224.742188 C 124.984375 220.617188 116.863281 213.855469 111.289062 205.183594 L 115.421875 202.523438 C 120.460938 210.359375 127.8125 216.476562 136.683594 220.210938 L 134.773438 224.742188 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 133.890625 226.707031 C 136.28125 227.605469 138.945312 226.394531 139.839844 224.007812 C 140.738281 221.621094 139.53125 218.953125 137.140625 218.058594 C 134.753906 217.160156 132.089844 218.367188 131.195312 220.757812 C 130.296875 223.144531 131.503906 225.808594 133.890625 226.707031 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 123.015625 151.9375 L 120.074219 148 C 128.335938 141.828125 138.3125 138.339844 148.921875 137.90625 L 149.121094 142.820312 C 139.503906 143.210938 130.476562 146.363281 123.015625 151.9375 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 148.800781 145 C 151.351562 144.996094 153.417969 142.921875 153.410156 140.371094 C 153.40625 137.820312 151.335938 135.753906 148.785156 135.757812 C 146.234375 135.761719 144.167969 137.835938 144.175781 140.386719 C 144.179688 142.9375 146.25 145.003906 148.800781 145 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 156.203125 171.308594 L 153.339844 167.3125 C 160.253906 162.359375 165.273438 154.824219 167.109375 146.640625 C 169.265625 137.042969 167.097656 126.566406 161.304688 118.613281 L 165.277344 115.71875 C 171.890625 124.796875 174.367188 136.757812 171.90625 147.71875 C 169.808594 157.0625 164.082031 165.660156 156.203125 171.308594 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 152.472656 165.265625 C 150.320312 166.636719 149.683594 169.492188 151.054688 171.644531 C 152.421875 173.796875 155.277344 174.433594 157.429688 173.0625 C 159.582031 171.695312 160.21875 168.839844 158.847656 166.6875 C 157.480469 164.53125 154.625 163.898438 152.472656 165.265625 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 180.695312 250.507812 C 173.589844 248.460938 167.195312 242.6875 162.207031 233.808594 C 160.480469 230.738281 158.992188 227.523438 157.554688 224.417969 C 155.664062 220.328125 153.875 216.464844 151.570312 212.839844 C 147.375 206.242188 141.53125 200.714844 134.671875 196.84375 L 137.085938 192.5625 C 144.644531 196.828125 151.085938 202.925781 155.714844 210.203125 C 158.195312 214.101562 160.136719 218.296875 162.015625 222.351562 C 163.414062 225.375 164.859375 228.496094 166.492188 231.398438 C 169.519531 236.789062 174.679688 243.660156 182.054688 245.785156 L 180.695312 250.507812 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 133.945312 198.945312 C 131.679688 197.773438 130.792969 194.984375 131.964844 192.71875 C 133.136719 190.453125 135.921875 189.5625 138.1875 190.734375 C 140.453125 191.90625 141.339844 194.695312 140.171875 196.960938 C 139 199.226562 136.210938 200.117188 133.945312 198.945312 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 203.4375 115.117188 C 203.136719 115.117188 202.847656 115.136719 202.5625 115.171875 C 200.09375 115.496094 197.203125 117.277344 197.203125 121.25 L 197.203125 290.078125 C 197.203125 291.839844 197.960938 293.519531 199.285156 294.6875 C 200.613281 295.859375 202.304688 296.382812 204.054688 296.160156 C 215.109375 294.757812 224.484375 289.8125 230.457031 282.226562 L 231.0625 281.457031 L 232.03125 281.3125 C 254.105469 278.0625 270.753906 258.753906 270.753906 236.398438 C 270.753906 225.898438 267.089844 215.664062 260.433594 207.570312 L 259.988281 207.027344 L 259.894531 206.332031 C 259.847656 205.976562 259.792969 205.625 259.730469 205.273438 L 259.542969 204.261719 L 260.128906 203.421875 C 264.640625 196.964844 267.023438 189.386719 267.023438 181.5 C 267.023438 166.707031 258.753906 153.496094 245.445312 147.019531 L 244.167969 146.398438 L 244.066406 144.980469 C 243.117188 131.488281 231.765625 120.917969 218.230469 120.917969 C 216.226562 120.917969 214.207031 121.152344 212.230469 121.621094 L 209.875 122.183594 L 209.226562 119.621094 C 208.335938 116.265625 205.722656 115.117188 203.4375 115.117188 Z M 203.300781 301.121094 C 200.644531 301.121094 198.054688 300.15625 196.035156 298.375 C 193.65625 296.273438 192.289062 293.25 192.289062 290.078125 L 192.289062 121.25 C 192.289062 114.589844 197.285156 110.902344 201.929688 110.296875 C 206.859375 109.652344 211.269531 112.109375 213.269531 116.40625 C 214.914062 116.136719 216.578125 116 218.230469 116 C 233.859375 116 247.039062 127.851562 248.839844 143.226562 C 255.484375 146.730469 261.109375 151.902344 265.167969 158.261719 C 269.597656 165.199219 271.9375 173.234375 271.9375 181.5 C 271.9375 189.988281 269.488281 198.160156 264.847656 205.214844 C 271.832031 214.0625 275.667969 225.09375 275.667969 236.398438 C 275.667969 248.546875 271.28125 260.277344 263.3125 269.425781 C 255.636719 278.242188 245.15625 284.113281 233.703125 286.027344 C 226.914062 294.203125 216.644531 299.519531 204.671875 301.035156 C 204.214844 301.09375 203.757812 301.121094 203.300781 301.121094 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 229.78125 286.121094 C 224.988281 286.121094 220.21875 285.019531 216.011719 282.90625 L 218.214844 278.511719 C 222.792969 280.8125 228.175781 281.683594 233.371094 280.957031 L 234.050781 285.824219 C 232.632812 286.023438 231.207031 286.121094 229.78125 286.121094 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 219.703125 276.824219 C 217.515625 275.511719 214.679688 276.226562 213.367188 278.417969 C 212.058594 280.605469 212.769531 283.441406 214.960938 284.753906 C 217.148438 286.0625 219.984375 285.351562 221.296875 283.160156 C 222.605469 280.972656 221.890625 278.136719 219.703125 276.824219 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 241.347656 224.742188 L 239.441406 220.210938 C 248.3125 216.476562 255.664062 210.359375 260.699219 202.523438 L 264.832031 205.183594 C 259.257812 213.855469 251.136719 220.617188 241.347656 224.742188 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 238.980469 218.058594 C 236.59375 218.953125 235.382812 221.621094 236.28125 224.007812 C 237.179688 226.394531 239.84375 227.605469 242.230469 226.707031 C 244.617188 225.808594 245.828125 223.144531 244.929688 220.757812 C 244.03125 218.367188 241.367188 217.160156 238.980469 218.058594 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 253.105469 151.9375 C 245.644531 146.363281 236.617188 143.210938 227 142.820312 L 227.199219 137.90625 C 237.8125 138.339844 247.789062 141.828125 256.046875 148 L 253.105469 151.9375 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 227.339844 135.757812 C 224.789062 135.753906 222.714844 137.820312 222.710938 140.371094 C 222.707031 142.921875 224.773438 144.996094 227.324219 145 C 229.875 145.003906 231.945312 142.9375 231.949219 140.386719 C 231.953125 137.835938 229.886719 135.761719 227.339844 135.757812 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 219.921875 171.308594 C 212.039062 165.660156 206.316406 157.0625 204.21875 147.71875 C 201.753906 136.757812 204.234375 124.796875 210.847656 115.71875 L 214.816406 118.613281 C 209.027344 126.566406 206.855469 137.042969 209.011719 146.640625 C 210.851562 154.824219 215.871094 162.355469 222.785156 167.3125 L 219.921875 171.308594 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 218.691406 173.0625 C 220.84375 174.433594 223.699219 173.796875 225.070312 171.644531 C 226.4375 169.492188 225.804688 166.636719 223.652344 165.265625 C 221.5 163.898438 218.644531 164.53125 217.273438 166.6875 C 215.90625 168.839844 216.539062 171.695312 218.691406 173.0625 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 195.425781 250.507812 L 194.066406 245.785156 C 201.445312 243.660156 206.605469 236.789062 209.632812 231.398438 C 211.265625 228.496094 212.710938 225.375 214.105469 222.351562 C 215.984375 218.296875 217.925781 214.101562 220.40625 210.203125 C 225.035156 202.925781 231.476562 196.828125 239.035156 192.5625 L 241.449219 196.84375 C 234.59375 200.714844 228.75 206.242188 224.554688 212.839844 C 222.246094 216.464844 220.460938 220.328125 218.566406 224.417969 C 217.128906 227.523438 215.644531 230.738281 213.917969 233.808594 C 208.929688 242.6875 202.535156 248.460938 195.425781 250.507812 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 237.933594 190.734375 C 240.199219 189.5625 242.988281 190.453125 244.160156 192.71875 C 245.328125 194.984375 244.441406 197.773438 242.175781 198.945312 C 239.910156 200.117188 237.125 199.226562 235.953125 196.960938 C 234.78125 194.695312 235.667969 191.90625 237.933594 190.734375 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 210.542969 310.203125 L 165.578125 310.203125 C 164.222656 310.203125 163.121094 309.101562 163.121094 307.746094 C 163.121094 306.386719 164.222656 305.289062 165.578125 305.289062 L 210.542969 305.289062 C 211.902344 305.289062 213.003906 306.386719 213.003906 307.746094 C 213.003906 309.101562 211.902344 310.203125 210.542969 310.203125 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 210.542969 319.890625 L 165.578125 319.890625 C 164.222656 319.890625 163.121094 318.789062 163.121094 317.433594 C 163.121094 316.074219 164.222656 314.976562 165.578125 314.976562 L 210.542969 314.976562 C 211.902344 314.976562 213.003906 316.074219 213.003906 317.433594 C 213.003906 318.789062 211.902344 319.890625 210.542969 319.890625 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 210.542969 329.578125 L 165.578125 329.578125 C 164.222656 329.578125 163.121094 328.476562 163.121094 327.117188 C 163.121094 325.761719 164.222656 324.660156 165.578125 324.660156 L 210.542969 324.660156 C 211.902344 324.660156 213.003906 325.761719 213.003906 327.117188 C 213.003906 328.476562 211.902344 329.578125 210.542969 329.578125 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 1.2, 1],
						opacity: [1, 0.9, 1],
						transition: {
							...transition,
							delay: 0.5,
						},
					},
				}}
				fill="#231f20"
				d="M 210.542969 339.261719 L 165.578125 339.261719 C 164.222656 339.261719 163.121094 338.164062 163.121094 336.804688 C 163.121094 335.449219 164.222656 334.347656 165.578125 334.347656 L 210.542969 334.347656 C 211.902344 334.347656 213.003906 335.449219 213.003906 336.804688 C 213.003906 338.164062 211.902344 339.261719 210.542969 339.261719 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.g
				clipPath="url(#c042a766ba)"
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
			>
				<motion.path
					variants={{
						idle: { scale: 1, opacity: 1 },
						active: {
							scale: [1, 2, 1],
							opacity: [1, 0.75, 1],
							transition: {
								...transition,
								delay: 0.3,
							},
						},
					}}
					fill="#231f20"
					d="M 188.0625 356.238281 C 178.15625 356.238281 170.097656 348.175781 170.097656 338.269531 L 170.101562 337.953125 L 175.015625 338.03125 L 175.011719 338.269531 C 175.011719 345.464844 180.867188 351.320312 188.0625 351.320312 C 195.257812 351.320312 201.109375 345.464844 201.109375 338.269531 C 201.109375 337.855469 201.089844 337.441406 201.050781 337.035156 L 205.945312 336.574219 C 205.996094 337.136719 206.023438 337.703125 206.023438 338.269531 C 206.023438 348.175781 197.964844 356.238281 188.0625 356.238281 "
					fillOpacity="1"
					fillRule="nonzero"
				/>
			</motion.g>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 188.0625 86.359375 C 186.703125 86.359375 185.605469 85.257812 185.605469 83.902344 L 185.605469 66.898438 C 185.605469 65.539062 186.703125 64.4375 188.0625 64.4375 C 189.417969 64.4375 190.519531 65.539062 190.519531 66.898438 L 190.519531 83.902344 C 190.519531 85.257812 189.417969 86.359375 188.0625 86.359375 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.g
				clipPath="url(#637050797e)"
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
			>
				<motion.path
					variants={{
						idle: { scale: 1, opacity: 1 },
						active: {
							scale: [1, 2, 1],
							opacity: [1, 0.75, 1],
							transition: {
								...transition,
								delay: 0.3,
							},
						},
					}}
					fill="#231f20"
					d="M 188.0625 39.429688 C 186.703125 39.429688 185.605469 38.328125 185.605469 36.972656 L 185.605469 21.226562 C 185.605469 19.871094 186.703125 18.773438 188.0625 18.773438 C 189.417969 18.773438 190.519531 19.871094 190.519531 21.226562 L 190.519531 36.972656 C 190.519531 38.328125 189.417969 39.429688 188.0625 39.429688 "
					fillOpacity="1"
					fillRule="nonzero"
				/>
			</motion.g>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 273.359375 122.210938 C 272.730469 122.210938 272.101562 121.972656 271.621094 121.492188 C 270.664062 120.535156 270.664062 118.976562 271.621094 118.015625 L 294.316406 95.316406 C 295.277344 94.355469 296.832031 94.355469 297.792969 95.316406 C 298.753906 96.273438 298.753906 97.832031 297.792969 98.789062 L 275.097656 121.492188 C 274.617188 121.972656 273.988281 122.210938 273.359375 122.210938 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 303.71875 91.84375 C 303.089844 91.84375 302.460938 91.605469 301.980469 91.125 C 301.023438 90.164062 301.023438 88.609375 301.980469 87.648438 L 315.925781 73.703125 C 316.886719 72.742188 318.441406 72.742188 319.398438 73.703125 C 320.359375 74.660156 320.359375 76.21875 319.398438 77.175781 L 305.457031 91.125 C 304.976562 91.605469 304.347656 91.84375 303.71875 91.84375 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				fill="#231f20"
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				d="M 329.378906 207.898438 L 308.328125 207.898438 C 306.972656 207.898438 305.871094 206.796875 305.871094 205.4375 C 305.871094 204.082031 306.972656 202.980469 308.328125 202.980469 L 329.378906 202.980469 C 330.734375 202.980469 331.835938 204.082031 331.835938 205.4375 C 331.835938 206.796875 330.734375 207.898438 329.378906 207.898438 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.g
				clipPath="url(#fe8f119705)"
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
			>
				<motion.path
					variants={{
						idle: { scale: 1, opacity: 1 },
						active: {
							scale: [1, 2, 1],
							opacity: [1, 0.75, 1],
							transition: {
								...transition,
								delay: 0.3,
							},
						},
					}}
					fill="#231f20"
					d="M 370.984375 207.898438 L 346.160156 207.898438 C 344.800781 207.898438 343.703125 206.796875 343.703125 205.4375 C 343.703125 204.082031 344.800781 202.980469 346.160156 202.980469 L 370.984375 202.980469 C 372.339844 202.980469 373.441406 204.082031 373.441406 205.4375 C 373.441406 206.796875 372.339844 207.898438 370.984375 207.898438 "
					fillOpacity="1"
					fillRule="nonzero"
				/>
			</motion.g>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 283.871094 304.609375 C 283.242188 304.609375 282.613281 304.371094 282.132812 303.890625 L 270.746094 292.5 C 269.789062 291.539062 269.789062 289.984375 270.746094 289.023438 C 271.707031 288.0625 273.261719 288.0625 274.222656 289.023438 L 285.609375 300.414062 C 286.570312 301.375 286.570312 302.929688 285.609375 303.890625 C 285.128906 304.371094 284.5 304.609375 283.871094 304.609375 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 315.050781 336.816406 L 291.984375 313.742188 C 291.023438 312.78125 291.023438 311.226562 291.984375 310.265625 C 292.941406 309.304688 294.5 309.304688 295.457031 310.265625 L 318.527344 333.339844 L 315.050781 336.816406 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 96.011719 297.859375 C 95.382812 297.859375 94.753906 297.621094 94.277344 297.140625 C 93.316406 296.179688 93.316406 294.625 94.277344 293.664062 L 99.789062 288.148438 C 100.75 287.191406 102.304688 287.191406 103.265625 288.148438 C 104.226562 289.109375 104.226562 290.664062 103.265625 291.625 L 97.75 297.140625 C 97.269531 297.621094 96.640625 297.859375 96.011719 297.859375 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 57.222656 336.660156 C 56.59375 336.660156 55.964844 336.421875 55.488281 335.941406 C 54.527344 334.980469 54.527344 333.425781 55.488281 332.464844 L 75.671875 312.273438 C 76.632812 311.3125 78.1875 311.3125 79.148438 312.273438 C 80.105469 313.234375 80.105469 314.789062 79.148438 315.75 L 58.960938 335.941406 C 58.480469 336.421875 57.851562 336.660156 57.222656 336.660156 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 66.558594 206.660156 L 44.121094 206.660156 C 42.765625 206.660156 41.664062 205.558594 41.664062 204.203125 C 41.664062 202.84375 42.765625 201.746094 44.121094 201.746094 L 66.558594 201.746094 C 67.914062 201.746094 69.015625 202.84375 69.015625 204.203125 C 69.015625 205.558594 67.914062 206.660156 66.558594 206.660156 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.g
				clipPath="url(#c59a20c785)"
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
			>
				<motion.path
					variants={{
						idle: { scale: 1, opacity: 1 },
						active: {
							scale: [1, 2, 1],
							opacity: [1, 0.75, 1],
							transition: {
								...transition,
								delay: 0.3,
							},
						},
					}}
					fill="#231f20"
					d="M 28.070312 206.660156 L 3.902344 206.660156 C 2.546875 206.660156 1.445312 205.558594 1.445312 204.203125 C 1.445312 202.84375 2.546875 201.746094 3.902344 201.746094 L 28.070312 201.746094 C 29.425781 201.746094 30.527344 202.84375 30.527344 204.203125 C 30.527344 205.558594 29.425781 206.660156 28.070312 206.660156 "
					fillOpacity="1"
					fillRule="nonzero"
				/>
			</motion.g>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 102.402344 121.339844 C 101.773438 121.339844 101.144531 121.097656 100.664062 120.617188 L 88.21875 108.171875 C 87.257812 107.210938 87.257812 105.652344 88.21875 104.695312 C 89.179688 103.734375 90.734375 103.734375 91.695312 104.695312 L 104.140625 117.144531 C 105.097656 118.101562 105.097656 119.660156 104.140625 120.617188 C 103.660156 121.097656 103.03125 121.339844 102.402344 121.339844 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 76.457031 95.390625 C 75.832031 95.390625 75.199219 95.148438 74.722656 94.667969 L 56.359375 76.304688 C 55.402344 75.34375 55.402344 73.785156 56.359375 72.828125 C 57.320312 71.867188 58.875 71.867188 59.835938 72.828125 L 78.195312 91.195312 C 79.15625 92.152344 79.15625 93.710938 78.195312 94.667969 C 77.714844 95.148438 77.089844 95.390625 76.457031 95.390625 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 148.277344 100.054688 C 147.460938 100.054688 146.664062 99.648438 146.195312 98.90625 L 139.058594 87.570312 C 138.335938 86.417969 138.683594 84.902344 139.832031 84.179688 C 140.976562 83.457031 142.496094 83.800781 143.21875 84.949219 L 150.355469 96.289062 C 151.078125 97.4375 150.730469 98.953125 149.582031 99.675781 C 149.175781 99.933594 148.726562 100.054688 148.277344 100.054688 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 132.964844 75.726562 C 132.148438 75.726562 131.351562 75.320312 130.882812 74.574219 L 120.871094 58.667969 C 120.148438 57.519531 120.492188 56 121.640625 55.277344 C 122.789062 54.554688 124.308594 54.898438 125.03125 56.046875 L 135.042969 71.957031 C 135.765625 73.105469 135.421875 74.625 134.273438 75.347656 C 133.867188 75.605469 133.414062 75.726562 132.964844 75.726562 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 228.964844 100.054688 C 228.519531 100.054688 228.066406 99.933594 227.660156 99.675781 C 226.511719 98.953125 226.167969 97.4375 226.890625 96.289062 L 234.996094 83.40625 C 235.71875 82.253906 237.238281 81.910156 238.386719 82.632812 C 239.535156 83.355469 239.878906 84.875 239.15625 86.023438 L 231.046875 98.90625 C 230.582031 99.648438 229.78125 100.054688 228.964844 100.054688 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 246.359375 72.417969 C 245.910156 72.417969 245.457031 72.296875 245.050781 72.042969 C 243.902344 71.316406 243.558594 69.800781 244.28125 68.652344 L 252.210938 56.046875 C 252.9375 54.898438 254.453125 54.554688 255.601562 55.277344 C 256.75 56 257.097656 57.519531 256.371094 58.667969 L 248.441406 71.269531 C 247.972656 72.011719 247.175781 72.417969 246.359375 72.417969 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 79.226562 162.898438 L 57.917969 153.148438 C 56.6875 152.585938 56.144531 151.125 56.707031 149.890625 C 57.273438 148.65625 58.730469 148.113281 59.964844 148.679688 L 81.269531 158.425781 L 79.226562 162.898438 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 44.332031 146.6875 C 43.988281 146.6875 43.640625 146.617188 43.3125 146.464844 L 24.257812 137.75 C 23.023438 137.183594 22.480469 135.726562 23.046875 134.492188 C 23.609375 133.257812 25.066406 132.714844 26.300781 133.277344 L 45.355469 141.996094 C 46.589844 142.558594 47.132812 144.019531 46.566406 145.253906 C 46.15625 146.15625 45.261719 146.6875 44.332031 146.6875 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 295.660156 162.898438 L 293.613281 158.425781 L 315.585938 148.375 C 316.820312 147.808594 318.277344 148.351562 318.84375 149.585938 C 319.40625 150.824219 318.867188 152.28125 317.632812 152.84375 L 295.660156 162.898438 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				fill="#231f20"
				d="M 341.007812 141.90625 C 340.074219 141.90625 339.1875 141.371094 338.773438 140.46875 C 338.207031 139.234375 338.75 137.777344 339.988281 137.214844 L 348.585938 133.277344 C 349.820312 132.714844 351.277344 133.257812 351.84375 134.492188 C 352.40625 135.726562 351.863281 137.183594 350.628906 137.75 L 342.03125 141.683594 C 341.699219 141.832031 341.351562 141.90625 341.007812 141.90625 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 64.785156 256.4375 C 63.902344 256.4375 63.054688 255.964844 62.613281 255.132812 C 61.976562 253.933594 62.429688 252.445312 63.628906 251.808594 L 78.222656 244.058594 C 79.421875 243.421875 80.910156 243.878906 81.546875 245.078125 C 82.183594 246.273438 81.726562 247.761719 80.527344 248.398438 L 65.933594 256.148438 C 65.566406 256.347656 65.171875 256.4375 64.785156 256.4375 "
				fillOpacity="1"
				fillRule="nonzero"
			/>

			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 30.855469 274.78125 L 28.550781 270.441406 L 50.1875 258.949219 C 51.386719 258.3125 52.871094 258.769531 53.507812 259.96875 C 54.144531 261.167969 53.691406 262.652344 52.492188 263.289062 L 30.855469 274.78125 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 307.28125 253.996094 C 306.890625 253.996094 306.5 253.902344 306.132812 253.710938 L 296.132812 248.398438 C 294.933594 247.761719 294.480469 246.273438 295.113281 245.078125 C 295.753906 243.878906 297.238281 243.421875 298.4375 244.058594 L 308.4375 249.367188 C 309.632812 250.003906 310.089844 251.492188 309.453125 252.691406 C 309.011719 253.523438 308.160156 253.996094 307.28125 253.996094 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
			<motion.path
				variants={{
					idle: { scale: 1, opacity: 1 },
					active: {
						scale: [1, 2, 1],
						opacity: [1, 0.75, 1],
						transition: {
							...transition,
							delay: 0.3,
						},
					},
				}}
				fill="#231f20"
				d="M 346.957031 275.070312 C 346.570312 275.070312 346.171875 274.976562 345.808594 274.78125 L 321.667969 261.960938 C 320.472656 261.324219 320.015625 259.835938 320.652344 258.640625 C 321.289062 257.441406 322.777344 256.984375 323.972656 257.621094 L 348.109375 270.441406 C 349.308594 271.078125 349.765625 272.5625 349.128906 273.761719 C 348.6875 274.59375 347.839844 275.070312 346.957031 275.070312 "
				fillOpacity="1"
				fillRule="nonzero"
			/>
		</motion.svg>
	)
}
